import "formdata-polyfill";

var serializeForm = function (formElement) {
    // Setup our serialized data
    var serialized = [];

    if (formElement === null) {
        return "";
    } else {
        // Loop through each field in the form
        for (var i = 0; i < formElement.elements.length; i++) {
            var field = formElement.elements[i];
            const isEmptyDatePicker =
                field.closest("ux-date-picker") !== null && field.value === "";
            const isCheckable =
                field.type === "checkbox" || field.type === "radio";

            // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
            if (
                !field.name ||
                field.disabled ||
                field.type === "file" ||
                field.type === "reset" ||
                field.type === "submit" ||
                field.type === "button"
            ) {
                continue;
            }

            // If a multi-select, get all selections
            if (field.type === "select-multiple") {
                for (var n = 0; n < field.options.length; n++) {
                    if (!field.options[n].selected) continue;
                    serialized.push(
                        encodeURIComponent(field.name) +
                            "=" +
                            encodeURIComponent(field.options[n].value)
                    );
                }
            }

            // Convert field data to a query string
            else if (
                (isCheckable && field.checked) ||
                (!isCheckable && !isEmptyDatePicker)
            ) {
                serialized.push(
                    encodeURIComponent(field.name) +
                        "=" +
                        encodeURIComponent(field.value)
                );
            }
        }

        /* console.log("new serialized", serialized.join("&")); */

        return serialized.join("&");
    }
};

export default serializeForm;
